import { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteUser,
  getUserDetails,
  logout,
  updateUserProfile,
} from "../actions/userActions";
import Loader from "../components/Loader";
import Message from "../components/Message";
import axios from "axios";
import { serverIp } from "../config/conf";
import { useNavigate, Link } from "react-router-dom";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import {
  USER_DETAILS_RESET,
  USER_LIST_RESET,
  USER_LOGOUT,
  USER_REGISTER_RESET,
  USER_UPDATE_PROFILE_RESET,
} from "../constants/userConstants";
import { Dialog, Transition } from "@headlessui/react";
import { auth } from "../config/firebase.config";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import { WISHLIST_CLEAR_ITEMS } from "../constants/wishListConstants";
import { CART_CLEAR_ITEMS } from "../constants/cartConstants";
import OtpInput from "otp-input-react";
import {
  ORDER_DETAILS_RESET,
  ORDER_MY_LIST_RESET,
} from "../constants/orderConstants";
import {
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputLeftAddon,
  Button,
} from "@chakra-ui/react";
import { FaWhatsapp } from "react-icons/fa";
import { toast } from "react-toastify";

export default function Profile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let [isOpen, setIsOpen] = useState(false);

  const [fName, setfName] = useState("");
  const [lName, setlName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [dob, setDob] = useState(null);
  const [doa, setDoa] = useState(null);
  const [gender, setGender] = useState("");
  const [mariedStatus, setMariedStatus] = useState("");
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const [whatsappError, setWhatsappError] = useState("");

  const [otpSent, setOtpSent] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [selectedOtpMethod, setOtpMethod] = useState('');

  const userDetails = useSelector((state) => state.userDetails);
  const { loading, error, user } = userDetails;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const userUpdateProfile = useSelector((state) => state.userUpdateProfile);
  const { success } = userUpdateProfile;

  const userDelete = useSelector((state) => state.userDelete);
  const { success: successDelete } = userDelete;

  useEffect(() => {

    if (!userInfo) {
      navigate("/signup");
    } else {
      if (!user?.firstName) {
        dispatch(getUserDetails());
      } else {
        setfName(user.firstName);
        setlName(user.lastName);
        setEmail(user.email);
        setPhone(user.phone?.replace(/^\+91/, "") || "");
        setWhatsapp(user.whatsapp?.replace(/^\+91/, ""));
        setGender(user.gender);
        setMariedStatus(user.mariedStatus);
        setIsEmailVerified(user.isEmailVerified);
        setIsPhoneVerified(user.isPhoneVerified);
        setDob(
          user?.dob !== null && user?.dob !== "" && user?.dob !== undefined
            ? new Date(user?.dob)?.toISOString()?.substring(0, 10)
            : null
        );
        setDoa(
          user?.doa !== null && user?.doa !== "" && user?.doa !== undefined
            ? new Date(user?.doa)?.toISOString()?.substring(0, 10)
            : null
        );
      }
    }

    if (successDelete) {
      navigate("/signup");
    }

    if (success) {
      dispatch({ type: USER_UPDATE_PROFILE_RESET });
      dispatch(getUserDetails());
      setOtpSent(false); setOtp("");
    }
  }, [userInfo, navigate, user, dispatch, success, successDelete]);

  const submitHandler = (e) => {
    e.preventDefault();

    dispatch(
      updateUserProfile({
        id: user._id,
        firstName: fName,
        lastName: lName,
        mariedStatus,
        dob,
        doa,
        gender,
      })
    );
  };

  const handleDelete = (id) => {
    setIsOpen(false);
    dispatch(deleteUser(id));
    dispatch(logout());
    localStorage.removeItem("userInfo");
    dispatch({ type: USER_LOGOUT });
    dispatch({ type: USER_REGISTER_RESET });
    dispatch({ type: USER_DETAILS_RESET });
    dispatch({ type: ORDER_MY_LIST_RESET });
    dispatch({ type: USER_UPDATE_PROFILE_RESET });
    dispatch({ type: ORDER_DETAILS_RESET });
    dispatch({ type: USER_LIST_RESET });
    dispatch({ type: CART_CLEAR_ITEMS });
    dispatch({ type: WISHLIST_CLEAR_ITEMS });
  };

  const handleInputChange = (value, name) => {

    if (name === "whatsapp") {
      setWhatsapp(value);
      setWhatsappError(
        validateWhatsappNumber(value) ? "" : "Invalid whatsapp number"
      );
    } else {
      setPhone(value);
      setPhoneError(
        validatePhoneNumber(value) ? "" : "Invalid phone number"
      );
    }
  };

  const validateWhatsappNumber = (phone) => {
    if (!phone) {
      setWhatsappError("");
      return true; // Allow empty input
    }

    // Check if input contains any alphabet character
    if (/[a-zA-Z]/.test(phone)) {
      setWhatsappError("Alphabets are not allowed. Please enter digits only.");
      return false;
    }

    // Now check if it's exactly 10 digits
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) {
      setWhatsappError("Please enter a valid 10-digit WhatsApp number.");
      return false;
    }

    setWhatsappError("");
    return true;
  };

  const validatePhoneNumber = (phone) => {

    // Check if input contains any alphabet character
    if (/[a-zA-Z]/.test(phone)) {
      setPhoneError("Alphabets are not allowed. Please enter digits only.");
      return false;
    }

    // Now check if it's exactly 10 digits
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) {
      setPhoneError("Please enter a valid 10-digit phone number.");
      return false;
    }

    setPhoneError("");
    return true;
  };

  const notify = (link, content, type) =>
    type(<Link to={link}>{content}</Link>);

  const sendOtp = async (e, method) => {
    e.preventDefault();
    setOtpLoading(true);

    if (method === "whatsapp" && !validateWhatsappNumber(whatsapp)) {
      setOtpLoading(false);
      notify("#", "Invalid whatsapp number", toast.error);
      return;
    }

    if (method === "sms" && !validatePhoneNumber(phone)) {
      setOtpLoading(false);
      notify("#", "Invalid phone number", toast.error);
      return;
    }

    try {

      if (method === "whatsapp") {
        setOtpMethod("whatsapp");
        await sendWhatsAppOtp();
      } else {
        setOtpMethod("sms");
        await sendFirebaseOtp();
      }

      setOtpSent(true);
    } catch (error) {
      console.error(error);
      notify("#", `${error}`, toast.error);
    } finally {
      setOtpLoading(false);
    }
  };

  const sendFirebaseOtp = async () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: () => console.log("Recaptcha verified"),
          "expired-callback": () => console.error("Recaptcha expired"),
        },
        auth
      );
    }

    try {
      const confirmationResult = await signInWithPhoneNumber(auth, `+91${phone}`, window.recaptchaVerifier);
      window.confirmationResult = confirmationResult;
      notify("#", "OTP has been successfully sent via SMS", toast.success);
    } catch (err) {
      notify("#", `Error sending OTP: ${err.message}`, toast.error);
    }
  };

  const sendWhatsAppOtp = async () => {
    try {
      const response = await axios.post(`${serverIp}/api/users/send-whatsapp-otp`, {
        name: `+91${whatsapp}`,
        phone: whatsapp,
      });
      // console.log("WhatsApp OTP sent successfully", response.data);
      notify("#", "Your OTP has been sent on WhatsApp", toast.success);
    } catch (err) {
      notify("#", `Error sending OTP: ${err.message}`, toast.error);
    }
  };

  const verifyOtp = (e) => {
    if (selectedOtpMethod === "whatsapp") {
      verifyWhatsAppOtp(e);
    } else {
      verifyFirebaseOtp(e);
    }
  }

  const verifyFirebaseOtp = (e) => {
    e.preventDefault();
    setOtpVerifying(true);
    if (!otp || otp.length !== 6) {
      notify("#", "Please enter a valid 6-digit OTP.", toast.error);
      setOtpVerifying(false);
      return;
    }

    window.confirmationResult
      .confirm(otp)
      .then((result) => {
        setOtpVerifying(false);
        document.getElementById("recaptcha-container").style.display = "none";
        const user = result.user;
        user.getIdToken().then((idToken) => {
          dispatch(
            updateUserProfile({
              id: user._id,
              phone: `+91${phone}`,
              isPhoneVerified: true,
            })
          );
        });
      })
      .catch((err) => {
        notify("#", "Invalid OTP: " + err.message, toast.error);
        setOtpVerifying(false);
        console.log(err);
      });
  };

  const verifyWhatsAppOtp = async (e) => {
    e.preventDefault();
    setOtpVerifying(true);

    if (!otp || otp.length !== 6) {
      notify("#", "Please enter a valid 6-digit OTP.", toast.error);
      setOtpVerifying(false);
      return;
    }

    try {
      const response = await axios.post(`${serverIp}/api/users/verify-whatsapp-otp`, {
        phone: `${whatsapp}`,
        otp,
      });

      const { success, message } = response.data;

      if (success) {
        dispatch(
          updateUserProfile({
            id: user._id,
            whatsapp: `+91${whatsapp}`,
          }))
      } else {
        // console.warn("Invalid OTP");
        notify("#", `${message}`, toast.error);
      }
    } catch (err) {
      // console.error("OTP verification failed:", err);
      notify("#", "OTP verification failed:", toast.error);
    } finally {
      setOtpVerifying(false);
    }
  };

  return (

    <div className="p-2 md:p-4 border-2 border-top bg-white">
      {loading ? (
        <Loader />
      ) : error ? (
        <Message type="error">{error}</Message>
      ) : (
        <form onSubmit={submitHandler}>
          <div className="space-y-4">
            <div className="border-b border-gray-900/10 pb-8">
              <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                <div className="sm:col-span-2">
                  <label
                    htmlFor="firstname"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    First Name
                  </label>
                  <div className="mt-2">
                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                      <input
                        type="text"
                        name="firstname"
                        id="firstname"
                        value={fName}
                        contentEditable
                        disabled
                        autoComplete="firstname"
                        className="disabled:cursor-not-allowed block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>
                </div>
                <div className="sm:col-span-2">
                  <label
                    htmlFor="lastname"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Last Name
                  </label>
                  <div className="mt-2">
                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                      <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={lName}
                        contentEditable
                        disabled
                        autoComplete="lastname"
                        className="disabled:cursor-not-allowed block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="DeleteAcc"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Delete Account
                  </label>
                  <button
                    type="button"
                    className="rounded-md mt-2 bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    onClick={() => setIsOpen(true)}
                  >
                    <RiDeleteBin5Line />
                  </button>
                </div>
              </div>
            </div>

            <div className="pb-12">
              <h2 className="text-base font-semibold leading-7 text-gray-900">
                Personal Information
              </h2>
              <p className="mt-1 text-sm leading-6 text-gray-600">
                Use a permanent address where you can receive mail.
              </p>

              <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

                <div className="sm:col-span-3">
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Phone {!otpLoading && !isPhoneVerified && phone.length > 9 && (
                      <span
                        onClick={(e) => {
                          e.preventDefault();
                          sendOtp(e, "sms");
                        }}
                        className="ml-2 text-blue-600 cursor-pointer hover:underline"
                      >
                        Click here to verify phone number
                      </span>
                    )}
                    {otpLoading && !isPhoneVerified && (
                      <span
                        className="ml-2 text-blue-600"
                      >
                        Please wait, sending OTP...
                      </span>
                    )}
                  </label>
                  <div className="relative mt-1 text-black">
                    <FormControl isInvalid={phoneError}>
                      <InputGroup>
                        <InputLeftAddon px="4" py="5" marginTop={2}>
                          +91
                        </InputLeftAddon>

                        <Input
                          type="text"
                          inputMode="numeric"
                          placeholder="Phone"
                          value={phone}
                          onChange={(e) => {
                            handleInputChange(e.target.value, "sms");
                            validatePhoneNumber(e.target.value);
                          }}
                          maxLength={10}
                          height={10}
                          px="4"
                          py="5"
                          color="black"
                          _disabled={{ color: "black", cursor: "not-allowed", }}
                          disabled={user?.isPhoneVerified}
                          border="1px"
                          borderColor="gray.300"
                          rounded="md"
                          marginTop={2}
                        />
                      </InputGroup>

                      <div className="absolute top-1/2 right-3 -translate-y-1/2 transform flex items-center">
                        {isPhoneVerified ? (
                          <IoShieldCheckmarkSharp className="h-4 w-4 text-green-500" />
                        ) : (
                          <IoShieldCheckmarkSharp className="h-4 w-4 text-red-500" />
                        )}
                      </div>

                      {phoneError && (
                        <FormErrorMessage>{phoneError}</FormErrorMessage>
                      )}
                    </FormControl>
                  </div>
                </div>


                <div className="sm:col-span-3">
                  <label
                    htmlFor="whatsapp"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    WhatsApp{" "}
                    <span className="font-normal text-gray-600">
                      (Optional — OTP and order details will be sent if provided)
                    </span>
                  </label>
                  {!otpLoading && !user?.whatsapp && whatsapp.length > 9 && (
                    <span
                      onClick={(e) => {
                        e.preventDefault();
                        sendOtp(e, "whatsapp");
                      }}
                      className="ml-2 text-blue-600 cursor-pointer hover:underline"
                    >
                      Click here to verify whatsapp number
                    </span>
                  )}
                  {otpLoading && !user?.whatsapp && (
                    <span
                      className="ml-2 text-blue-600"
                    >
                      Please wait, sending OTP...
                    </span>
                  )}
                  <div className="relative mt-1">
                    <FormControl isInvalid={whatsappError}>
                      <InputGroup>
                        <InputLeftAddon px="4" py="5" marginTop={2}>
                          <FaWhatsapp className="text-green-500 mr-1" /> +91
                        </InputLeftAddon>

                        <Input
                          type="text"
                          inputMode="numeric"
                          placeholder="Whatsapp"
                          value={whatsapp}
                          onChange={(e) => {
                            handleInputChange(e.target.value, "whatsapp");
                            validateWhatsappNumber(e.target.value);
                          }}
                          maxLength={10}
                          width="full"
                          height={10}
                          px="4"
                          py="5"
                          border="1px"
                          borderColor="gray.300"
                          rounded="md"
                          marginTop={2}
                          _disabled={{ color: "black", cursor: "not-allowed", }}
                          disabled={user?.whatsapp}
                        />
                      </InputGroup>
                      {whatsappError && (
                        <FormErrorMessage>{whatsappError}</FormErrorMessage>
                      )}
                    </FormControl>
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Email address
                  </label>
                  <div className="relative mt-2">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      contentEditable
                      disabled
                      value={email}
                      autoComplete="email"
                      className="disabled:cursor-not-allowed block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5">
                      <button type="button" className="focus:outline-none">
                        {isEmailVerified ? (
                          <IoShieldCheckmarkSharp
                            className="h-4 w-4 text-green-500"
                            aria-hidden="true"
                          />
                        ) : (
                          <IoShieldCheckmarkSharp
                            className="h-4 w-4 text-red-500"
                            aria-hidden="true"
                          />
                        )}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="dob"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Date Of Birth
                  </label>
                  <div className="mt-2">
                    <input
                      id="dob"
                      name="dob"
                      type="date"
                      value={dob}
                      onChange={(e) => setDob(e.target.value)}
                      autoComplete="dob"
                      className="disabled:cursor-not-allowed block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="gender"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Gender
                  </label>

                  <div className="flex gap-4 items-center">
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="gender"
                        value="Male"
                        checked={gender === "Male"}
                        onChange={(e) => {
                          if (gender === e.target.value) {
                            setGender("");
                          } else {
                            setGender(e.target.value);
                          }
                        }}
                        className="form-radio text-[#000080]"
                      />
                      Male
                    </label>

                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="gender"
                        value="Female"
                        checked={gender === "Female"}
                        onChange={(e) => {
                          if (gender === e.target.value) {
                            setGender("");
                          } else {
                            setGender(e.target.value);
                          }
                        }}
                        className="form-radio text-[#000080]"
                      />
                      Female
                    </label>

                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="gender"
                        value="Other"
                        checked={gender === "Other"}
                        onChange={(e) => {
                          if (gender === e.target.value) {
                            setGender("");
                          } else {
                            setGender(e.target.value);
                          }
                        }}
                        className="form-radio text-[#000080]"
                      />
                      Other
                    </label>
                  </div>
                </div>

                <div className="sm:col-span-3">
                  <label
                    htmlFor="mariedStatus"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Status
                  </label>

                  <div className="flex gap-4 items-center">
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="mariedStatus"
                        value="Single"
                        checked={mariedStatus === "Single"}
                        onChange={(e) => {
                          if (mariedStatus === e.target.value) {
                            setMariedStatus("");
                          } else {
                            setMariedStatus(e.target.value)
                          }
                        }}
                        className="form-radio text-[#000080]"
                      />
                      Single
                    </label>

                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="mariedStatus"
                        value="Married"
                        checked={mariedStatus === "Married"}
                        onChange={(e) => {
                          if (mariedStatus === e.target.value) {
                            setMariedStatus("");
                          } else {
                            setMariedStatus(e.target.value)
                          }
                        }}
                        className="form-radio text-[#000080]"
                      />
                      Married
                    </label>
                  </div>
                </div>

                <div className="sm:col-span-3">
                  {mariedStatus === "Married" && (
                    <>
                      <label
                        htmlFor="doa"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Date Of Anniversary
                      </label>
                      <div className="mt-2">
                        <input
                          id="doa"
                          name="doa"
                          type="date"
                          value={doa}
                          onChange={(e) => setDoa(e.target.value)}
                          autoComplete="doa"
                          className="disabled:cursor-not-allowed block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>


              <div className="flex items-center gap-x-6 mt-8">
                <button
                  type="submit"
                  className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Save
                </button>
              </div>
              <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                  as="div"
                  className="relative z-10"
                  onClose={() => setIsOpen(false)}
                >
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                  </Transition.Child>

                  <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                      <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                      >
                        <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                          <Dialog.Title className="pb-2 text-lg font-bold">
                            Deactivate account
                          </Dialog.Title>
                          <Dialog.Description className="pb-2">
                            This will permanently deactivate your account
                          </Dialog.Description>

                          <p className="pb-2">
                            Are you sure you want to deactivate your account?
                            All of your data will be permanently removed. This
                            action cannot be undone.
                          </p>

                          <button
                            className="mx-1 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                            onClick={(e) => handleDelete(user._id)}
                          >
                            Deactivate
                          </button>
                          <button
                            className="mx-1 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                            onClick={() => setIsOpen(false)}
                          >
                            Cancel
                          </button>
                        </Dialog.Panel>
                      </Transition.Child>
                    </div>
                  </div>
                </Dialog>
              </Transition>
            </div>
            {otpSent && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg p-6 w-80 shadow-lg text-center">
                  <label htmlFor="">
                    Enter OTP
                  </label>
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    OTPLength={6}
                    autoFocus
                    otpType="number"
                    inputStyles={{
                      width: "100%", // Allows input width to fill container in mobile view
                      maxWidth: "40px", // Sets a maximum width to prevent overflow on larger screens
                      margin: "0 4px", // Simplifies margin for better spacing
                      fontSize: "16px", // Slightly larger for readability
                      textAlign: "center",
                      padding: "4px", // Minimal padding to prevent text clipping
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                    }}
                    className="opt-container flex w-full justify-center px-2 py-2"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        verifyOtp(e);
                      }
                    }}
                  />
                  <Button
                    type="button"
                    onClick={verifyOtp}
                    bgColor="#000080"
                    _hover={{ bgColor: "#000090" }}
                    color="white"
                    isLoading={otpVerifying}
                    loadingText="Loading..."
                    w="full"
                    py="2"
                    fontSize="sm"
                  >
                    Verify OTP
                  </Button>
                  <button
                    className="mt-4 text-sm text-red-600 underline"
                    onClick={() => { setOtpSent(false); setOtp(""); }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </form>
      )}
    </div>

  );
}
